import React from 'react';
import { Link } from 'react-router-dom';
import HeroSlider from '../components/HeroSlider';
import './Home.css';
import { ArrowRight, Info, User } from 'lucide-react';

const Home = () => {
  return (
    <div className="home-page">
      <HeroSlider />
      
      <div className="container sections">
        <section className="home-section odonata-intro">
          <div className="section-icon emerald">
            <Info size={40} />
          </div>
          <div className="section-content">
            <h2>The World of Odonata</h2>
            <p>
              Dragonflies and damselflies, belonging to the order Odonata, are more than just beautiful insects. 
              They are ancient predators that have inhabited our planet for over 300 million years, serving as 
              crucial indicators of freshwater ecosystem health.
            </p>
            <Link to="/about-odonata" className="btn btn-primary">
              Learn More <ArrowRight size={18} />
            </Link>
          </div>
        </section>

        <section className="home-section me-intro reverse">
          <div className="section-icon amber">
            <User size={40} />
          </div>
          <div className="section-content">
            <h2>Meet the Researcher</h2>
            <p>
              Driven by a passion for entomology and biodiversity conservation, I spend my time in the field 
              documenting these winged wonders. From forest streams to urban wetlands, every observation is 
              a piece of the environmental puzzle.
            </p>
            <Link to="/about-me" className="btn btn-secondary">
              About Me <ArrowRight size={18} />
            </Link>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Home;
